import React from "react";
import { PenLine, Image as ImageIcon, Heart } from "lucide-react";

export default function GuidelinesGrid() {
  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-10 py-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0">
              <PenLine className="w-5 h-5" />
            </span>
            <h3 className="font-bold text-slate-900 text-base">
              Write Original Content
            </h3>
          </div>
          <ul className="text-sm text-slate-600 space-y-2 list-disc pl-4 mb-6 flex-1">
            <li>Share your own experiences and opinions.</li>
            <li>Avoid copying content from other websites or blogs.</li>
            <li>Use your own words and writing style.</li>
            <li>Make sure your information is accurate and useful.</li>
            <li>Add personal experiences wherever possible.</li>
          </ul>
          <div className="bg-purple-50 rounded-xl p-4 text-sm text-slate-700">
            <span className="font-semibold text-[#7209B7]">Tip:</span> Your
            unique experience is what makes your story valuable.
          </div>
        </div>

        <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0">
              <ImageIcon className="w-5 h-5" />
            </span>
            <h3 className="font-bold text-slate-900 text-base">
              Add High-Quality Images
            </h3>
          </div>
          <p className="text-sm font-medium text-slate-800 mb-3">
            Make your blog more engaging with relevant travel photos.
          </p>
          <ul className="text-sm text-slate-600 space-y-2 list-disc pl-4 mb-6 flex-1">
            <li>Use clear, high-quality images.</li>
            <li>Upload images that are relevant to your story.</li>
            <li>Use photos you own or have permission to use.</li>
            <li>Avoid copyrighted images without permission.</li>
            <li>Add captions when they provide useful context.</li>
          </ul>
          <img
            src="/img/dashboard/writer-guidelines-images.svg"
            alt="Travel photos"
            className="w-full h-auto object-contain"
          />
        </div>

        <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0">
              <Heart className="w-5 h-5" />
            </span>
            <h3 className="font-bold text-slate-900 text-base">
              Keep It Respectful
            </h3>
          </div>
          <p className="text-sm font-medium text-slate-800 mb-3">
            SoloConnect is a community of travelers from different
            backgrounds.
          </p>
          <ul className="text-sm text-slate-600 space-y-2 list-disc pl-4 mb-6 flex-1">
            <li>Share honest experiences without targeting individuals.</li>
            <li>Be considerate when discussing people and places.</li>
            <li>Respect local cultures and communities.</li>
            <li>Avoid stereotypes.</li>
          </ul>
          <img
            src="/img/dashboard/writer-guidelines-respect.svg"
            alt="Travelers together"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
